import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "media-tools-container bsp-page" }
const _hoisted_2 = { class: "main-content bsp-page__content" }
const _hoisted_3 = { class: "bsp-tool-grid" }
const _hoisted_4 = {
  class: "bsp-section media-section",
  "aria-labelledby": "media-lookup-title"
}
const _hoisted_5 = {
  key: 0,
  class: "bsp-response-card"
}
const _hoisted_6 = {
  key: 0,
  class: "bsp-response-card"
}
const _hoisted_7 = {
  key: 2,
  class: "bsp-response-card"
}

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref } from 'vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AEmptyViewCard, AInput, ATag } from '@adereso-ai/vue-components'


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaToolsView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')

const mediaUrlResponse = ref('')
const DownloadmediaUrlResponse = ref('')
const mediaID = ref('')
const mediaUrl = ref('')

const mediaBreadcrumbs = [
  { title: 'WhatsApp Accounts', icon: 'tabler:brand-whatsapp', to: { name: 'whatsapp-business-accounts' } },
  { title: 'Media tools', disabled: true }
]

async function getMedia () {
  if (mediaID.value === '') {
    toastError('Media ID is required')
    return
  }

  const metaService = await MetaService.getInstance()
  try {
    const mediaUrlResp = await metaService.getMediaUrl(mediaID.value)
    mediaUrlResponse.value = mediaUrlResp
    mediaUrl.value = mediaUrlResp.url
  } catch (error) {
    toastError(error as string)
  }
}

async function downloadMedia () {
  if (mediaUrl.value === '') {
    toastError('Media URL is required')
    return
  }

  const metaService = await MetaService.getInstance()
  try {
    const mediaUrlResp = await metaService.downloadMediaUrl(mediaID.value, mediaUrl.value)
    DownloadmediaUrlResponse.value = mediaUrlResp
  } catch (error) {
    toastError(error as string)
  }
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BspPageHeader, {
        breadcrumbs: mediaBreadcrumbs,
        title: "Media tools",
        description: "Look up a Meta file by ID and download its content.",
        eyebrow: "Administrative utilities",
        icon: "tabler:photo"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bsp-section-heading" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Step 1"),
              _createElementVNode("h2", { id: "media-lookup-title" }, "Find file"),
              _createElementVNode("p", null, "Get the temporary URL associated with the identifier from Meta.")
            ])
          ], -1)),
          _createVNode(_unref(AInput), {
            modelValue: mediaID.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mediaID).value = $event)),
            label: "File ID",
            placeholder: "Enter the media ID",
            "prepend-inner-icon": "tabler:fingerprint",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(AButton), {
            color: "blue",
            "prepend-icon": "tabler:search",
            disabled: !mediaID.value,
            onClick: getMedia
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Get URL ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          (mediaUrlResponse.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(ATag), {
                  text: "URL found",
                  color: "success",
                  type: "secondary",
                  "prepend-icon": "tabler:check"
                }),
                _createElementVNode("code", null, _toDisplayString(mediaUrlResponse.value.url), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["bsp-section media-section", { 'bsp-section--disabled': !mediaUrl.value }]),
          "aria-labelledby": "media-download-title"
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bsp-section-heading" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Step 2"),
              _createElementVNode("h2", { id: "media-download-title" }, "Download file"),
              _createElementVNode("p", null, "Download the content using the URL obtained in the previous step.")
            ])
          ], -1)),
          (mediaUrl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "URL ready to download", -1)),
                _createElementVNode("code", null, _toDisplayString(mediaUrl.value), 1)
              ]))
            : (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                key: 1,
                icon: "tabler:link-off",
                title: "Find a file first",
                description: "The download will be enabled when a valid URL is available."
              })),
          _createVNode(_unref(AButton), {
            color: "blue",
            "prepend-icon": "tabler:download",
            disabled: !mediaUrl.value,
            onClick: downloadMedia
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Download file ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          (DownloadmediaUrlResponse.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(ATag), {
                  text: "Download complete",
                  color: "success",
                  type: "secondary"
                }),
                _createElementVNode("code", null, _toDisplayString(DownloadmediaUrlResponse.value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})